<template>
    <div>
        <div class="mb-4 text-sm text-gray-600">
            This is a secure area of the application. Please confirm your password before continuing.
        </div>

        <form @submit.prevent="submit">
            <FormGroup name="password" label="Password">
                <Input v-model="form.password" type="password" required autofocus autocomplete="current-password"/>
            </FormGroup>

            <div class="flex justify-end mt-4">
                <SubmitButton
                    :submitting="form.processing"
                    :disabled="form.errors.any()">
                    Login
                </SubmitButton>
            </div>
        </form>
    </div>
</template>

<script>

import FormGroup from "@/Components/Form/FormGroup";
import Input from "@/Components/Form/Input";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    name: "ConfirmPasswordForm",

    data() {
        return {
            form: this.$form({
                password: '',
            })
        }
    },

    emits: ['success'],

    provide() {
        return {
            form: this.form
        };
    },

    components: {
        SubmitButton,
        FormGroup,
        Input,
    },

    methods: {
        submit() {
            this.form.post(route('password.confirm'))
                .then(() => {
                    this.$emit('success');
                })
                .catch(console.error)
        }
    }
}
</script>
